import { render, staticRenderFns } from "./aboutUs.vue?vue&type=template&id=12ba152c&scoped=true&"
import script from "./aboutUs.vue?vue&type=script&lang=js&"
export * from "./aboutUs.vue?vue&type=script&lang=js&"
import style0 from "./aboutUs.vue?vue&type=style&index=0&id=12ba152c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12ba152c",
  null
  
)

export default component.exports